const { addToCart } = window.vtexjs.checkout;

const GIFTCARD_CATEGORY_ID = window.location.href.indexOf('swiftqa') > -1 ? '174' : '0';

const htmlModal = `
<div class="rnk-componente-modal-alert-gift-card-checkout modal fade" id="ModalAlertGiftCardCheckout" tabindex="-1" role="dialog" aria-labelledby="Modal Alerta Cartão Presente" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
        <div class="modal-body">
            <h3>VOCÊ TEM PRODUTOS<br>NO CARRINHO</h3>
            <p>O cartão presente não pode ser adicionado ao carrinho junto com outros produtos.</p>
            <p>
                <button type="button" class="btn rnk-btn-success btn-success" data-dismiss="modal" aria-label="Fechar">FECHAR</button>
            </p>
        </div>
    </div>
  </div>
</div>
<style>
  #ModalAlertGiftCardCheckout {
    text-align: center;
  }

  #ModalAlertGiftCardCheckout .modal-content{
    border-radius: 26px 0 50px 50px;
  }

  #ModalAlertGiftCardCheckout .modal-dialog {
        width: 96%;
        max-width: 572px;
    }

  #ModalAlertGiftCardCheckout h3 {
    font-size: 32px;
    font-family: "Barlow Condensed", sans-serif;
    font-weight: 700;
    letter-spacing: 3.2px;
    color: #3E3A36;
    box-sizing: border-box;
    padding-top: 24px;
  }
  #ModalAlertGiftCardCheckout h3 + p {
    color: #3E3A36;
    padding: 20px 76px 0;
    letter-spacing: 0.8px;
    line-height: 22px;
    margin-bottom: 28px;
  }
  #ModalAlertGiftCardCheckout button{
    border-radius: 50rem;
    width: 250px;
  }
</style>
`;

/**
 * Verify if modal is already in body, if not, add it
 */
const addModalToBody = () => {
  if (!$('.rnk-componente-modal-alert-gift-card-checkout').length) {
    const $modal = $(htmlModal);
    $('body').append($modal);
    // triggers
    $modal.find('button').on('click', () => {
      $('#ModalAlertGiftCardCheckout').modal('hide');
    });
  }
};

const openModal = () => {
  addModalToBody();
  $('#ModalAlertGiftCardCheckout').modal('show');
};

const hasGiftCardInCheckout = () => {
  return vtexjs.checkout.orderForm.items.some((item) => {
    const productCategoryIds = Object.keys(item.productCategories);
    return productCategoryIds.includes(GIFTCARD_CATEGORY_ID);
  });
};

const hasNonGiftCardInCheckout = () => {
  return vtexjs.checkout.orderForm.items.some((item) => {
    const productCategoryIds = Object.keys(item.productCategories);
    return !productCategoryIds.includes(GIFTCARD_CATEGORY_ID);
  });
};

if (window.swiftGiftCardAllowedToBuy) {
  (() => {
    const isGiftCardInItems = async (items: string[]) => {
      try {
        const skus = await window.storeTheme.helpers.getSkuInfoByProductList(items, 'skuId', {
          useFqFilterProducts: false,
        });
        if (Object.keys(skus).some((sku) => skus[sku].categoriesIds.includes(GIFTCARD_CATEGORY_ID))) {
          return true;
        }
      } catch (error) {
        console.error(error);
      }
      return false;
    };
    window.vtexjs.checkout.addToCart = async (items, salesChannel, salesChannelSelector) => {
      try {
        const hasGiftCardInList = await isGiftCardInItems(items?.map((item) => item.id));

        if (hasGiftCardInList && hasNonGiftCardInCheckout()) {
          // alert(
          //   'Você não pode adicionar um vale presente ao carrinho com outros produtos. Remova os produtos do carrinho para continuar',
          // );
          openModal();
          return {
            ...vtexjs.checkout.orderForm,
            messages: [
              {
                code: 'GiftCardWithOtherProducts',
                text: 'Você não pode adicionar um vale presente ao carrinho com outros produtos',
              },
            ],
          };
          // throw new Error('Nom-gift card already in checkout');
        } else if (hasGiftCardInCheckout() && !hasGiftCardInList) {
          openModal();
          // alert(
          //   'Você não pode adicionar outros produtos ao carrinho, pois já possui um vale presente adicionado. Remova o vale presente do carrinho para continuar',
          // );
          return {
            ...vtexjs.checkout.orderForm,
            messages: [
              {
                code: 'OtherProductWithGiftCard',
                text: 'Você não pode adicionar outros produtos ao carrinho, pois já possui um vale presente adicionado',
              },
            ],
          };
          // throw new Error('Gift card already in checkout');
        }
      } catch (error) {
        console.error('Error on custom addToCart', error);
      }

      return await addToCart(items, salesChannel, salesChannelSelector);
    };
  })();
}

// window.vtexjs.checkout.updateItems = async (items, salesChannel, salesChannelSelector) => {
//   const result = await updateItems(items, salesChannel, salesChannelSelector);
//   return result;
// };

export default {};
